// extracted by mini-css-extract-plugin
export default {"container":"freeTrial_container__aVpsX","title":"freeTrial_title__GQejP","record-label":"freeTrial_record-label__UGmqM"};